import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DxDataGridComponent } from 'devextreme-angular';
import { Role } from 'src/app/models/role';
import { GroupData } from '../../forecast/activity/models/activity-data.model';
import { SettingsService } from '../settings.service';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss'],
    standalone: false
})
export class RoleComponent implements OnInit {
  showInfoPopup: boolean;
  infoPopupMessage: string;
  infPopupTitle: string;

  constructor(private settingsService: SettingsService,
    private titleService: Title) { }

  roleName: string = "";

  tableValuesDataSource: Role[];
  roleData: Role;
  editRolePopup = false;
  changedtableValuesDataSourceRecords: Role[] = [];
  @ViewChild('editingDataGrid', { static: false }) dataGrid: DxDataGridComponent;
  dataSource: any;

  ngOnInit() {
    this.titleService.setTitle("Role");
    this.loadPage();
  }
  loadPage() {

    this.settingsService.GetRole(0)
      .subscribe(result => {
        this.tableValuesDataSource = result;

      });
  }

  onResize() {
    setTimeout(() => {
    });
  }

  unsavedChanges = false;
  gridRowUpdated(e) {
    this.unsavedChanges = true;
    this.addOrReplace(e.data);
  }

  arrIndex = {};
  addOrReplace(object) {
    let index = this.arrIndex[object.roleId];
    if (index === undefined) {
      index = this.changedtableValuesDataSourceRecords.length;
      this.arrIndex[object.roleId] = index;
    }
    this.changedtableValuesDataSourceRecords[index] = object;
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    toolbarItems.unshift({
      location: 'before',
      template: 'saveButtonTemplate'
    }, {
      location: 'before',
      template: 'undoButtonTemplate'
    }
      , {
        location: 'before',
        template: 'addRoleButtonTemplate'
      }
    );
  }

  saveAllChanges() {
    if (this.unsavedChanges) {
      this.data = [];
      this.changedtableValuesDataSourceRecords.forEach(item => {
        this.dataItem = new GroupData();
        this.dataItem.KeyPair = item.roleId.toString();
        this.dataItem.ValuePair = item.roleName;
        this.data.push(this.dataItem);
      });


      this.settingsService.UpdateAddRole(this.data).subscribe(result => {
        this.infoPopupMessage = 'Changes Saved Successfully!';
        this.infPopupTitle = 'Saved';
        let flag = 0;
        if (result.returnFlag.length > 0) {
          this.infoPopupMessage = result.returnFlag[0].msg;
          this.infPopupTitle = result.returnFlag[0].retrunData;
          
        }
        this.showInfoPopup = true;
        this.unsavedChanges = false;
        this.changedtableValuesDataSourceRecords = [];
        this.loadPage();
        setTimeout(() => {
          this.changeInfoPopupStatus();
        }, 5000);

      }, (error) => {

      });

    } else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'No changes have been done yet.';
      this.infPopupTitle = 'Warning';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);

    }
  }

  undoAllChanges() {
    if (this.unsavedChanges) {
      this.dataGrid.instance.beginCustomLoading('Reverting changes');
      this.loadPage();
      this.unsavedChanges = false;
      this.dataGrid.instance.endCustomLoading();
    } else {
      this.showInfoPopup = true;
      this.infoPopupMessage = 'No changes have been done yet.';
      this.infPopupTitle = 'Warning';

      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 3000);
    }
  }


  changeInfoPopupStatus() {
    this.showInfoPopup = false;
    this.infoPopupMessage = '';
    this.infPopupTitle = '';
  }

  addNewRole(evnt) {
    this.editRolePopup = true;
  }

  cancelNewRole() {
    this.editRolePopup = false;
  }

  data: GroupData[];
  dataItem: GroupData;

  saveNewRole(evnt) {
    this.data = [];
    this.dataItem = new GroupData();
    this.dataItem.KeyPair = '0';
    this.dataItem.ValuePair = this.roleName;
    this.data.push(this.dataItem);

    this.settingsService.UpdateAddRole(this.data).subscribe(result => {
      this.infoPopupMessage = 'Changes Saved Successfully!';
      this.infPopupTitle = 'Saved';
      let flag = 0;
      if (result.returnFlag.length > 0) {
        this.infoPopupMessage = result.returnFlag[0].msg;
        this.infPopupTitle = result.returnFlag[0].retrunData;
        flag = result.returnFlag[0].flag;
      }
      this.showInfoPopup = true;
      this.unsavedChanges = false;
      this.changedtableValuesDataSourceRecords = [];
      if (flag > 0) {
        this.editRolePopup = false;
      }

      this.loadPage();
      setTimeout(() => {
        this.changeInfoPopupStatus();
      }, 5000);

    }, (error) => {

    });
  }

}
